import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
export function Container({ as, variant = "normal", className, innerStyle, children, ...rest }) {
    const Component = as ?? "div";
    return (_jsx(Component, { className: "cvr-container-block", ...rest, children: _jsx("div", { className: classNames("cvr-container", className, {
                "cvr-container--fluid": variant === "fluid",
            }), style: innerStyle, children: children }) }));
}
